export const NAVIGATION_DATA_LOAD = 'navigation/DATA_LOAD'
